module.exports = __webpack_public_path__ + "img/arms_5_1.cea639cb.png";